import React, { useContext, useState } from 'react';
import { validateNumber, validateString } from './validation';
import { BookDetail, LanguageContextData } from './types';
import { textValues, LanguageContext } from './utils';

interface BookDetailFormProps {
  setBookDetail: (bookDetail: BookDetail) => void
};

const BookDetailForm = ({ setBookDetail }: BookDetailFormProps) => {
  const { language } = useContext<LanguageContextData>(LanguageContext);
  const [ childName, setChildName ] = useState<string>('');
  const [ childGender, setChildGender ] = useState<string>('');
  const [ childAge, setChildAge ] = useState<number>(1);
  const [ topic, setTopic ] = useState<string>('');
  const [ learning, setLearning ] = useState<string>('');
  const [ contextKeywords, setContextKeywords ] = useState<string[]>([]);

  return (
    <article>
      <h1>{ textValues[language]['details'] }</h1>
      <form>
        <div className='row'>
          <label htmlFor='childName'>{ textValues[language]['detailsName'] }</label>
          <input className={ !!!validateString(childName, 3, 15) ? 'error' : '' } type='text' id='childName' value={ childName } onChange={ (e) => setChildName(e.target.value) }/>
        </div>
        <div className='row'>
          <label htmlFor='childGender'>{ textValues[language]['detailsGender'] }</label>
          <select id='childGender' value={ childGender } onChange={ (e) => setChildGender(e.target.value) }>
            <option value=''>{ textValues[language]['detailsChild'] }</option>
            <option value='boy'>{ textValues[language]['detailsBoy'] }</option>
            <option value='girl'>{ textValues[language]['detailsGirl'] }</option>
          </select>
        </div>
        <div className='row'>
          <label htmlFor='childAge'>{ textValues[language]['detailsAge'] }</label>
          <div className='input'><input className={ !!!validateNumber(childAge, 1, 30) ? 'error' : '' }  type='number' id='childAge' min='0' max='30' value={ childAge + '' }  onChange={ (e) => setChildAge(parseInt(e.target.value)) }/>{ textValues[language]['detailsAgeText'] }</div>
        </div>
        <div className='row'>
          <label htmlFor='topic'>{ textValues[language]['detailsTopic'] }</label>
          <input className={ !!!validateString(topic, 3, 100) ? 'error' : '' } type='text' id='topic' value={ topic } onChange={ (e) => setTopic(e.target.value) }/>
        </div>
        <div className='row'>
          <label htmlFor='learning'>{ textValues[language]['detailsLearning'] }</label>
          <input className={ !!!validateString(learning, 3, 100) ? 'error' : '' } type='text' id='learning' value={ learning } onChange={ (e) => setLearning(e.target.value) }/>
        </div>
        <div className='row'>
          <label htmlFor='contextKeywords'>{ textValues[language]['detailsKeywords'] }</label>
          <input className={ contextKeywords.filter(keyword => !!!validateString(keyword, 3, 100)).length > 0 ? 'error' : '' } type='text' id='contextKeywords' value={ contextKeywords.join(';') } onChange={ (e) => setContextKeywords(e.target.value.split(';')) }  onBlur={ (e) => setContextKeywords(e.target.value.split(';').map(v => v.trim()).filter(v => v !== '')) }/>
        </div>
        <div className='row'>
          &nbsp;
          <button disabled={ !!!(validateString(childName, 3, 15) && validateNumber(childAge, 1, 30) && validateString(topic, 3, 100) && validateString(learning, 3, 100) && contextKeywords.filter(keyword => !!!validateString(keyword, 3, 100)).length === 0) } onClick={ (e) => { e.preventDefault(); setBookDetail({
            childName,
            childGender,
            childAge,
            topic,
            learning,
            contextKeywords
          }) }}>{ textValues[language]['detailsButton'] }</button> 
        </div>
      </form>
    </article>
  );
};

export default BookDetailForm;